import Mweb from "../src/mweb/Mweb";
import Dweb from "../src/dweb/dweb";
import { useMediaQuery } from "react-responsive";
// import { useEffect } from "react";
// import { useAuthState } from "react-firebase-hooks/auth";
// import { auth } from "./firebase/firebase";
// import { useAppDispatch } from "./redux/hooks";
// import { login } from "./redux/features/userSlice";

const App = () => {
  // const [user] = useAuthState(auth);
  // const dispatch = useAppDispatch();

  // useEffect(() => {
  //   if (user) {
  //     dispatch(login(user));
  //   }
  // }, [user, dispatch]);

  const isMobile = useMediaQuery({ maxWidth: 767 });

  return <>{isMobile ? <Mweb /> : <Dweb />}</>;
};

export default App;
